import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  previewArea: {
    pointerEvents: "none",

    margin: theme.hvSpacing("xs"),

    "&>*": {
      margin: theme.hvSpacing("xs", 0),
    },

    "& a:focus": {
      outline: `1px ${theme.hv.palette.accent.acce3} dotted`,
    },
  },
}));

export default useStyles;
